RN.showCard = function() {
    function init(show, selectedTime24, response, dateOrTimeChanged) {

        var compareTime;
        if (selectedTime24) {
            var compareTime = selectedTime24;
        }
        var showTimes = ''
            
        var showPrices = ''
        var memberPricing = false;

        for (var i = 0; i < show.price.length; i++) {
            if (show.price[i].showRRP) {
                memberPricing = true;
            }
            showPrices += '<p class="performance-card__price">$' + show.price[i].price + ' per ' + show.price[i].name.replace("LSC Member ", "") + '</p>';
        }

        if (memberPricing) {

            var showPricesActual = showPrices;

            showPrices = '<div style="background:#F4F4F4;padding:10px 10px 1px 10px;border-radius:8px;margin:0 0 10px 0;"><div style="opacity:0.5">';
            for (var i = 0; i < show.price.length; i++) {
                showPrices += '<p class="performance-card__price">$' + show.price[i].priceRRP + ' per ' + show.price[i].name.replace("LSC Member ", "") + '</p>';
            }
            showPrices += '</div>';
            showPrices += '<div style="border-top: 1px solid #DDD;padding: 10px 0 0 0;">';
            showPrices += '<div style="font-size:16px;padding-bottom:5px;">Member-Only Prices</div>';
            showPrices += showPricesActual;
            showPrices += '</div>';
        }


        var description = show.description ? show.description : ''

        for (var i = 0; i < show.performances.length; i++) {

            showTimes += '<div class="custom-checkbox custom-checkbox--button u-mb-half">';

            // console.log("IF " + show.performances[i].datetime + " < " + show.performances[i].todaydate + ' ' + compareTime);
            // only allow user to select shows after they are planning on arriving

            var datePassed = (Date.parse(show.performances[i].datetime) < (Date.parse(show.performances[i].todaydate + 'T' + compareTime + '+00:00') + 1800)) ? true : false;

            if(show.performances[i].available === false || show.performances[i].soldout === true || datePassed) {
                showTimes += '<input class="custom-checkbox__input" type="radio" disabled="disabled">';
                showTimes += '<label class="custom-checkbox__label custom-checkbox__label--small';
                if (show.performances[i].available === false || datePassed) {
                    showTimes += ' custom-checkbox__label--unavailable" style="opacity:0.3';
                }
                else if(show.performances[i].soldout === true) {
                    showTimes += ' custom-checkbox__label--soldout';
                }
                showTimes += '"><span>';

                if (show.performances[i].available === false || datePassed) {
                    showTimes += '<em>Unavailable</em>';
                }
                else if(show.performances[i].soldout === true) {
                    showTimes += '<em>Sold out</em>';
                }
                showTimes += show.performances[i].time + '</span></label>';

            }
            else {
                var selected = response.stored.showTimes ? (response.stored.showTimes[show.productionId] ? response.stored.showTimes[show.productionId].includes(show.performances[i].performanceId_zoneId.toString()) : false) : false;
                if (dateOrTimeChanged) {
                    selected = false
                }
                showTimes += '<input class="custom-checkbox__input" ';
                if (selected) {
                    showTimes += 'checked="checked" ';
                }
                showTimes += 'id="showtime_' + show.performances[i].performanceId_zoneId + '" type="radio" ' +
                    'data-behaviour="showtime-toggle" data-ignore-conflicts="' + show.cmsData.ignore_conflicts + '" data-duration="' + show.cmsData.duration + '" data-datetime="' + show.performances[i].datetime + '" data-time24="' + show.performances[i].time24 + '" data-time="' + show.performances[i].time + '" data-name="' + show.name + '" value="' + show.performances[i].performanceId_zoneId + '" ' +
                    'name="showTimes[' + show.productionId + '][]"><label class="custom-checkbox__label custom-checkbox__label--small" ' +
                    'for="showtime_' + show.performances[i].performanceId_zoneId + '">' + show.performances[i].time + '</label>';
            }

            showTimes += '</div>';
        }


        var modalMarkup = '<aside class="modal-desktop modal-desktop--with-image" data-element="show-' + show.productionId  + '-info" data-class="modal-desktop--active">' +
            '<div class="modal-desktop__bg" data-behaviour="modal-trigger" data-target="show-' + show.productionId  + '-info"></div>' +
            '<div class="modal-desktop__body">' +
                '<div class="modal-desktop__header">' +
                    '<button type="button" class="modal-desktop__close" data-behaviour="modal-trigger" data-target="show-' + show.productionId  + '-info">' +
                        '<span class="sr-only">close modal</span>' +
                    '</button>' +
                '</div>' +
                '<div class="modal-desktop__container modal-desktop__container--has-fixed-button-container">' +
                    '<div class="u-pr-30 u-pb u-pl-30">' +
                        '<p class="performance-card__heading">' + show.cmsData.modalTitle + '</p>' +
                        '<p class="performance-card__desc u-mb0 u-pb">' + show.cmsData.modalDescription + '</p>';

                    if (show.cmsData.youtubeId != "") { 

                        modalMarkup += '<div class="youtubeBlock youtubeBlockResponsive16by9">' +
                            '<iframe class="youtube-player" src="//www.youtube.com/embed/' + show.cmsData.youtubeId + '?color=red&controls=1&hl=en&iv_load_policy=1&modestbranding=1&rel=0&showinfo=1" frameborder="0" allowfullscreen></iframe>' +
                        '</div>';

                    }
                    else if (show.cmsData.modalImage != "") {
                        modalMarkup += '<img src="' + show.cmsData.modalImage + '" class="modal-desktop__img" />';
                    }

                    modalMarkup += '</div>' +
                '</div>' +
            '</div>' +
        '</aside>';

        var html = '<div class="grid__item">' +
            '<article class="performance-card show">' +
                '<img class="performance-card__image" src="' + show.cmsData.thumbnail + '" />' +
                '<div class="performance-card__content">' +
                    '<h1 class="performance-card__heading">' + show.name + '</h1>' +
                    '<div class="performance-card__price-container">' + showPrices + '</div>' +
                    '<p class="performance-card__desc">' + description + '</p>' +
                    '<div data-behaviour="modal-container">'+
                        '<button class="button button--text-icon u-mb-30" data-behaviour="modal-trigger" data-target="show-' + show.productionId  + '-info" type="button">More Info' +
                            '<svg class="button__icon" role="presentation"><use xlink:href="#icon-chevron-circle"></use></svg>' +
                        '</button>' +
                        modalMarkup +
                    '</div>'+
                    '<hr class="hr hr--spaced u-mb" />' +
                    '<div class="performance-card__times">' +
                        '<div class="u-df u-wrap u-justify-spaced u-align-center u-mb-half">' +
                            '<p class="performance-card__heading performance-card__heading--small">Choose a time</p>';

                            if (!show.cmsData.hide_duration) {                            
                                html += '<div class="u-df"><svg class="performance-card__clock" role="presentation"><use xlink:href="#icon-clock"></use></svg><p class="performance-card__time">' + show.cmsData.duration + ' mins</p></div>';
                            }

                        html += '</div>' +
                        '<div class="u-df u-wrap">' + showTimes + '</div>' +
                    '</div>' +
                '</div>' +
            '</article>' +
        '</div>';

        return html;
    }

    return {
        init: init
    };
}()
